import client from "./client";

// 메인 data
export const mainData = locale => client.get(`/api/${locale}/main/list`);

// 건강한 자원자 참여 연구
export const healthyStudy = (locale, page) =>
  client.get(`/api/${locale}/main/healtyStudyList?pgNum=${page}`);

// 질환 자원자 참여 연구
export const diseaseStudy = (locale, page) =>
  client.get(`/api/${locale}/main/disasesStudyList?pgNum=${page}`);
